<vc-autocomplete
    #autocomplete
    [label]="label"
    [placeholder]="placeholder"
    [suffixIcon]="minimalStyles ? 'filter_alt' : ''"
    [required]="required"
    [requiredText]="requiredText"
    [minimalStyles]="minimalStyles"
    [(value)]="org"
    [options]="orgs"
    [showClear]="true"
    [itemRenderer]="orgRenderer"
    [optionTemplate]="showTags ? orgTemplate : orgNameTemplate"
    [loading]="loading"
    [filterDebounceInterval]="0"
    [panelWidth]="panelWidth"
    [disabled]="disabled"
    (valueChange)="orgChange.emit(org)"
    (filterChange)="searchOrgs($event)"></vc-autocomplete>

<ng-template #orgNameTemplate let-org>
    <vc-tooltip-text [text]="orgRenderer(org)" [tooltipMessage]="orgRenderer(org)"></vc-tooltip-text>
</ng-template>

<ng-template #orgTemplate let-org>
    <div class="vc-org-filter-option">
        <vc-tooltip-text class="vc-org-filter-option-name" [text]="orgRenderer(org)"></vc-tooltip-text>
        <vc-chip-tags class="vc-org-filter-option-tags" [tags]="org?.tags" [showCount]="1"></vc-chip-tags>
    </div>
</ng-template>
